import { Hidden } from '@material-ui/core'
import momentJalaali from 'moment-jalaali'
import { useEffect, useState } from 'react'

import ViewSelector from '../../../components/ViewSelector'
import { addDaysToDate, DateObject, getTodayDate } from '../../../helpers/date'
import { getTranslate } from '../../../localization'
import { PaymentTermAssignmentRow } from '../../../types/walletPaymentTerm'
import AssignmentRow from './AssignmentRow'
import DateRow from './DateRow'
import useStyles from './styles/index.styles'

interface PaymentTermAssignmentTableProps {
  assignments: PaymentTermAssignmentRow[]
  coveringRange: DateObject
}

type RangeType = {
  label: string
  value: 'THREE_MONTH' | 'MONTH' | 'YEAR'
}

export const PaymentTermAssignmentTable = ({
  assignments,
  coveringRange
}: PaymentTermAssignmentTableProps) => {
  const classes = useStyles()
  const [selectedRange, setselectedRange] = useState(0)

  const RANGE_ITEMS: RangeType[] = [
    {
      label: getTranslate('View one Month'),
      value: 'MONTH'
    },
    {
      label: getTranslate('View Three Months'),
      value: 'THREE_MONTH'
    },
    {
      label: getTranslate('View one Year'),
      value: 'YEAR'
    }
  ]

  const [calendarDateRange, setCalendarDateRange] = useState<DateObject>({
    gregorianStartDate: getTodayDate(),
    gregorianEndDate: addDaysToDate(getTodayDate(), 30) // Default to 1 month (30 days)
  })

  useEffect(() => {
    if (coveringRange.gregorianStartDate && coveringRange.gregorianEndDate) {
      let startDate = coveringRange.gregorianStartDate // assuming you get this value from your input

      // Adjust startDate if it's before today
      if (momentJalaali(startDate).isBefore(momentJalaali())) {
        startDate = momentJalaali().format('YYYY-MM-DD') // set startDate to today's date
      }

      let endDate = null

      if (RANGE_ITEMS[selectedRange].value === 'MONTH') {
        endDate = addDaysToDate(startDate, 31)
      } else if (RANGE_ITEMS[selectedRange].value === 'THREE_MONTH') {
        startDate = momentJalaali(startDate)
          .startOf('month')
          .format('YYYY-MM-DD')
        endDate = addDaysToDate(startDate, 90)
      } else {
        startDate = momentJalaali(startDate)
          .startOf('month')
          .format('YYYY-MM-DD')
        endDate = addDaysToDate(startDate, 365)
      }

      setCalendarDateRange({
        gregorianStartDate: startDate,
        gregorianEndDate: endDate
      })
    }
  }, [
    selectedRange,
    coveringRange.gregorianStartDate,
    coveringRange.gregorianEndDate
  ])

  return (
    <div className={classes.root}>
      <Hidden smDown>
        <div className={classes.header}>
          <div className={classes.datePickerContainer}></div>
          <ViewSelector
            options={RANGE_ITEMS}
            selectedIndex={selectedRange}
            onSelectionChange={setselectedRange}
          />
        </div>

        {coveringRange &&
          coveringRange.gregorianStartDate &&
          coveringRange.gregorianEndDate && (
            <>
              <DateRow
                selectedDateInDatePicker={calendarDateRange}
                setselectedDateInDatePicker={setCalendarDateRange}
                range={RANGE_ITEMS[selectedRange].value}
              />
              {assignments.map((assignment: PaymentTermAssignmentRow) => (
                <AssignmentRow
                  assignment={assignment}
                  range={RANGE_ITEMS[selectedRange].value}
                  calendarDate={calendarDateRange}
                  selectedRangeForAssignments={coveringRange}
                />
              ))}
            </>
          )}
      </Hidden>
    </div>
  )
}
